"use client";

import React from 'react';
import { useRevealOnScroll } from '@/hooks/useRevealOnScroll';
import { ShieldCheck, Clock, Database } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
export default function DataRetention() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: areCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const retentionPolicies = [{
    title: "Retention Principle",
    description: "We adhere to strict data minimization. We maintain retention only for as long as reasonably necessary for the purpose collected, unless longer retention is required by law or legitimate business needs.",
    icon: Clock,
    label: "CORE POLICY"
  }, {
    title: "Business Inquiries",
    description: "Information submitted through contact forms is retained to facilitate professional communication and service delivery, subject to periodic review and secure disposal protocols.",
    icon: Database,
    label: "OPERATIONAL"
  }, {
    title: "Legal Compliance",
    description: "Certain records may be preserved for extended periods to meet regulatory, tax, or legal obligations specific to the UAE jurisdiction and international standards.",
    icon: ShieldCheck,
    label: "REGULATORY"
  }];
  return <section data-section-id="253275" id="data-retention" className="bg-[#0F172A] text-[#F8FAFC] w-full min-h-screen py-14 md:py-18 lg:py-20 border-t border-white/5 scroll-mt-[120px] snap-start">
      <div className="max-w-7xl mx-auto px-6">
        
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-block px-3 py-1 mb-4 border border-[#13B8C8]/30 rounded-lg bg-[#13B8C8]/5">
            <span className="font-mono text-xs font-semibold tracking-widest text-[#13B8C8] uppercase">
              Lifecycle Management
            </span>
          </div>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-[#F8FAFC] tracking-tight">
            Data Retention & Disposal
          </h2>
          <p className="font-default text-base md:text-lg text-[#CBD5E1] leading-relaxed">
            At FETC, we maintain rigorous standards for data lifecycle management. Our retention policies are designed to balance operational necessity with the highest levels of privacy and Data Rights & Compliance Requests.
          </p>
        </div>

        <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 delay-300 ease-out ${areCardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          {retentionPolicies.map((policy, i) => <Card key={i} data-index={i} className="group bg-[#142033] border-[rgba(19,184,200,0.18)] hover:border-[#13B8C8]/50 transition-all duration-300 shadow-lg rounded-lg overflow-hidden flex flex-col h-full py-0">
              <CardHeader className="p-6 pb-0">
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 rounded-lg bg-[#0B1220] text-[#13B8C8] group-hover:scale-110 transition-transform duration-300">
                    <policy.icon className="w-6 h-6" />
                  </div>
                  <span className="font-mono text-[10px] tracking-widest text-[#CBD5E1]/60 uppercase">
                    {policy.label}
                  </span>
                </div>
                <CardTitle className="font-default text-xl font-semibold text-[#F8FAFC]">
                  {policy.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-6 pt-2">
                <p className="font-default text-sm md:text-base text-[#CBD5E1] leading-relaxed">
                  {policy.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

      </div>
    </section>;
}